import { FaRegCheckCircle } from "react-icons/fa";
import {
  AccordionFormHeader,
  CollabFormAccordion,
  DraftStatusHolder,
} from "../BrandCollabComponents/BrandCollabAtomicComponent";
import { ArrowRight, CircleAlert } from "lucide-react";
import { LinkedinPostEditor } from "../LinkedinEditor";
import { Button } from "../../../../../shadcnComponents/ui/button";
import mixpanel from "mixpanel-browser";

export const ShareDraftPage = ({
  collab,
  handleSaveLinkedinDraft,
  handleSendForApproval,
  setCurrentStep,
  isDraftSaving,
}) => {
  return (
    <>
      <div>
        <div className="flex justify-between mb-6">
          <div className="text-start space-y-2">
            <h1 className="text-[#FFF] font-[Inter] text-[20px] not-italic font-bold leading-[24px]">
              Campaign Draft
            </h1>
            <p className="text-[#9E9E9E] font-[Inter] text-[14px] not-italic font-normal leading-[20px]">
              Write the draft here & format it just like how you would want it
              to appear on LinkedIn
            </p>
          </div>
          <div>
            <DraftStatusHolder
              title="DRAFT STATUS"
              status={
                <>
                  {collab?.brandApproval === "accepted" ? (
                    <span className="flex gap-1 items-center">
                      <FaRegCheckCircle
                        className="h-4 w-4"
                        color="#fff"
                        fill="#115E59"
                      />
                      Approved
                    </span>
                  ) : (
                    <span className="flex gap-2 items-center">
                      <CircleAlert className="h-4 w-4" />
                      PENDING
                    </span>
                  )}
                </>
              }
              variant={
                collab?.brandApproval === "accepted" ? "approved" : "pending"
              }
            />
          </div>
        </div>
        <div className="space-y-4 pb-4">
          {collab?.draft && collab?.draft?.length > 0 ? (
            <div className="flex flex-col gap-4">
              {collab?.draft?.[0]?.suggestedChanges &&
                collab?.brandApproval === "suggested" && (
                  <CollabFormAccordion
                    defaultValue="open_1"
                    Header={<AccordionFormHeader title="Revised Draft" />}
                    ContentArray={[
                      <LinkedinPostEditor
                        // header={{
                        //   title: `Share your revised draft`,
                        //   description:
                        //     "Write the draft here & format it just like how you would want it to appear on LinkedIn",
                        // }}
                        initial={{
                          editorMode: "edit",
                          docid: "",
                          content: "",
                          isApproved: collab?.brandApproval === "accepted",
                        }}
                        onSaveDraft={handleSaveLinkedinDraft}
                        onSendForApproval={handleSendForApproval}
                        isDraftSaving={isDraftSaving}
                        isDraftExpired={collab?.isDraftExpired}
                      />,
                    ]}
                  />
                )}
              {collab?.draft?.map((item, index) => {
                return (
                  <CollabFormAccordion
                    key={index}
                    defaultValue={`open_${index + 2}`}
                    Header={
                      <AccordionFormHeader
                        title={
                          item?.suggestedChanges?.comment?.length ||
                          item?.status === 1
                            ? `Draft ${index + 1}`
                            : "Draft"
                        }
                      />
                    }
                    ContentArray={[
                      <LinkedinPostEditor
                        key={index}
                        // header={{
                        //   title: item?.suggestedChanges?.comment?.length
                        //     ? `Campaign draft ${index + 1}`
                        //     : "Share your draft",
                        //   description: item?.suggestedChanges?.comment?.length
                        //     ? "Your old draft"
                        //     : `Write the draft here & format it just like how you would want it to appear on LinkedIn`,
                        // }}
                        initial={{
                          editorMode: item?.status === 1 ? "view" : "edit",
                          docid: item?._id,
                          content: item?.postText,
                          images: item?.postImages,
                          video: item?.postVideos,
                          suggestionComment: item?.suggestedChanges?.comment,
                          suggestionImages: item?.suggestedChanges?.images,
                          isApproved:
                            index === 0 && collab?.brandApproval === "accepted",
                        }}
                        onSaveDraft={handleSaveLinkedinDraft}
                        onSendForApproval={handleSendForApproval}
                        isDraftSaving={isDraftSaving}
                        isDraftExpired={collab?.isDraftExpired}
                      />,
                    ]}
                  />
                );
              })}
            </div>
          ) : (
            <CollabFormAccordion
              defaultValue="open_2"
              Header={<AccordionFormHeader title="Share your draft" />}
              ContentArray={[
                <LinkedinPostEditor
                  // header={{
                  //   title: "Share your draft",
                  //   description:
                  //     "Write the draft here & format it just like how you would want it to appear on LinkedIn",
                  // }}
                  initial={{
                    editorMode: "edit",
                  }}
                  onSaveDraft={handleSaveLinkedinDraft}
                  onSendForApproval={handleSendForApproval}
                  isDraftSaving={isDraftSaving}
                  isDraftExpired={collab?.isDraftExpired}
                />,
              ]}
            />
          )}
        </div>
        {collab?.brandApproval === "accepted" && (
          <div className="w-full flex justify-end">
            <Button
              onClick={() => {
                mixpanel.track(
                  `Influencer Brand Collab Details  : Share Draft - Visited `
                );
                setCurrentStep(4);
              }}
              variant="destructive"
              className="gap-3 min-w-[180px]"
            >
              Share Live Link
              <ArrowRight size={16} />
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
